import React from "react";

class MainItem extends React.Component {
  shouldComponentUpdate = (nextProps) => {
    if (this.props.active === nextProps.active) return false;
    return true;
  }
  handleClick = (e, isTap) => {
    if (isTap) {
      this.props.onTouch(e);
    } else if (!this.props.isTouch) {
      this.props.onClick(e);
    }

    let sendLog = true;

    switch(e.currentTarget.id) {
      case 'inicio_main_menu':
        window.dataLayer.push({event: 'click_menu', menu: 'inicio', accion: 'click'});
        break;

      case 'trabajador_main_menu':
        window.dataLayer.push({event: 'click_menu', menu: 'trabajador', contenido: 'menu_trabajador', accion: 'click'});
        break;

      case 'empresa_main_menu':
        window.dataLayer.push({event: 'click_menu', menu:'Empresa', contenido: 'menu_empresa', accion: 'click'});
        break;

      case 'soporte_main_menu':
        window.dataLayer.push({event: 'click_menu', menu: 'Soporte', contenido: 'menu_soporte', accion: 'click'});
        break;

      case 'mi_cuenta_main_menu':
        window.dataLayer.push({event: 'click_menu', menu: 'mi_cuenta', contenido: 'menu_mi_cuenta', accion: 'click'});
        break;

      default:
        sendLog = false;
        break;
    }
  }

  render() {
    const {
      text,
      icon,
      active,
      id,
      noExpand,
    } = this.props;

    return (
      <div
        className={`main-menu-item ${active ? "active" : ""}`}
        onClickCapture={(e) => {
          if (!active) {
            this.handleClick(e, false);
          }
        }}
        id={id}
        onTouchStart={(e) => this.handleClick(e, true)}
        onMouseEnter={() => {
          if (this.props.onMouseEnter) {
            this.props.onMouseEnter(!noExpand);
          }
        }}
      >
        <i className="achs-icon">{icon}</i>
        <span>{text}</span>
      </div>
    );
  }
}

export default MainItem;
